import React from "react";
import { Link } from "react-router-dom";
import { CheckIcon, ChevronRightIcon } from "lucide-react";
import { CtaPair } from "../CtaPair";
import { QuoteForm } from "../QuoteForm";
type PageHeroProps = {
  breadcrumb: string;
  eyebrow: string;
  title: string;
  highlight: string;
  intro: string;
  image: string;
  imageAlt: string;
  facts: string[];
  quoteLabel?: string;
  defaultNeed?: string;
  logo?: {
    src: string;
    alt: string;
  };
};
export function PageHero({
  breadcrumb,
  eyebrow,
  title,
  highlight,
  intro,
  image,
  imageAlt,
  facts,
  quoteLabel,
  defaultNeed,
  logo
}: PageHeroProps) {
  return <section className="relative bg-soft" aria-labelledby="page-title" data-id="element-204" data-mp="aow5oyu40rzv">
      <div className="mx-auto grid max-w-[1440px] lg:min-h-[660px] lg:grid-cols-[0.95fr_1.05fr]" data-id="element-205" data-mp="5pt0nee4qlrw">
        <div className="flex items-center px-5 py-7 lg:px-10 lg:py-10 xl:pl-16" data-id="element-206" data-mp="1m3j72rsq1m4p">
          <div className="max-w-2xl" data-id="element-207" data-mp="1m5m8e7zbr1oq">
            <nav aria-label="Breadcrumb" data-id="element-208" data-mp="1h5hmu3jk7grn">
              <ol className="flex flex-wrap items-center gap-2 text-xs font-semibold text-muted" data-id="element-209" data-mp="1h4g9fsf2mi6r">
                <li data-id="element-210" data-mp="1fhfacx22jehv">
                  <Link to="/" className="transition-colors duration-150 ease-out hover:text-rinnai" data-id="element-211" data-mp="1jjacu4vqjxx8">Home</Link>
                </li>
                <li aria-hidden="true" data-id="element-212" data-mp="1oi3tu7a8e725"><ChevronRightIcon className="h-3.5 w-3.5" data-id="element-213" data-mp="1ojom1q92pdwu" /></li>
                <li aria-current="page" className="text-ink" data-id="element-214" data-mp="1thzxg5f0nwh6">{breadcrumb}</li>
              </ol>
            </nav>
            {logo && <img src={logo.src} alt={logo.alt} className="mt-6 h-10 w-auto sm:h-12" data-id="element-215" data-mp="vur45o8rxj4m" />}
            <p className="mt-6 text-xs font-bold tracking-[0.07em] text-muted" data-id="element-216" data-mp="10s14hyxpbf78">{eyebrow}</p>
            <h1 id="page-title" className="mt-4 text-[2.5rem] font-bold leading-[1.05] tracking-[-0.05em] sm:text-5xl xl:text-6xl" data-id="element-217" data-mp="15rdo8ata065l">
              {title} <span className="text-rinnai" data-id="element-218" data-mp="1ak6w37k1julw">{highlight}</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-8 text-muted" data-id="element-219" data-mp="d26o57e6b8i8">{intro}</p>
            <ul className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-220" data-mp="i1jcxxolupng">
              {facts.map(fact => <li key={fact} className="flex items-start gap-2 text-sm font-bold leading-5 text-ink" data-id="element-221" data-mp="a0tuptnuk7u7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rinnai" aria-hidden="true" data-id="element-222" data-mp="60tfw7wu5umm" />
                  {fact}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-223" data-mp="eslnmauh6pni">
              <CtaPair quoteLabel={quoteLabel} data-id="element-224" data-mp="etmz2gfele5r" />
            </div>
            <p className="mt-4 text-xs font-semibold text-muted" data-id="element-225" data-mp="3n7vj303v0wmb">Free quote · No obligation · Perth metro installation</p>
          </div>
        </div>

        <div className="relative bg-stone pb-5 lg:min-h-full lg:pb-0" data-id="element-226" data-mp="3j84qcqurw6f5">
          <img src={image} alt={imageAlt} className="h-[300px] w-full object-cover lg:absolute lg:inset-0 lg:h-full" data-id="element-227" data-mp="11ynce92grpb" />
          <div className="relative mx-5 -mt-10 lg:absolute lg:bottom-8 lg:right-8 lg:m-0 lg:w-[390px] xl:right-12" data-id="element-228" data-mp="3s5ncjyk5kqsm">
            <QuoteForm defaultNeed={defaultNeed} data-id="element-229" data-mp="1ci6ukszg0r7b" />
          </div>
        </div>
      </div>
    </section>;
}